import Vue from "vue";

require('dotenv').config();

export function config(key) {
    return process.env[`VUE_APP_${key}`]
}

export function short(string, limit) {
    if (! string) {
        return string;
    }

    if (string.length <= limit) {
        return string;
    }

    return string.substr(0, limit) + '...';
}

export function formatDate(date) {
    if (!date) return null;
    date = new Date(date);
    return (
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes()
    );
}

function generateTranslatable(keys) {
    const result = {};
    keys.forEach(({ key, type }) => {
        result[key] = type === 'array' ? [] : "";
    });
    return result;
}

export function moneyFormat(string){ //for use : use in interal javascript
    string = string.toString();
    var pos = 1;
    var output = "";
    for(var i = (string.length-1) ; i >= 0 ; i--){
        output += string.charAt(i);
        if(pos % 3 === 0 && i > 0){
            output += ",";
        }
        pos++;
    }
    output = reverse(output);
    return output;
}

export function reverse(s) {
    var o = [];
    for (var i = 0, len = s.length; i <= len; i++){
        o.push(s.charAt(len - i));
    }
    return o.join('');
}